module.exports = __webpack_public_path__ + "img/news_updates.bf9c179c.svg";